// Root path
export const ROOT_PATH = '/';
// LogIn/LogOut AEM endpoints
export const AUTHENTICATION_CURRENT_USER_ENDPOINT = '/services/yme/authentication/current-user';
export const REFRESH_ACCESS_TOKEN_ENDPOINT = '/services/yme/authentication/oauth2/refresh-access-token';
export const AUTHENTICATION_LOGOUT_ENDPOINT = '/services/yme/authentication/oauth2/logout';
export const LOGIN_TIMEOUT_ENDPOINT = '/services/yme/authentication/login-timeout';
// wishlist
export const WISHLIST_ENDPOINT = '/services/api/wishlist';
// Endpoints Salesforce (for login & logout)
export const SALES_FORCE_AUTHORIZE_ENDPOINT = '/services/oauth2/authorize';
export const SALES_FORCE_LOGOUT_ENDPOINT = '/services/auth/idp/oidc/logout';
export const SALES_FORCE_SIGN_UP_ENDPOINT = '/s/login/SelfRegister';
// Endpoints Salesforce (for Notify me)
export const NOTIFY_ME_BACK_IN_STOCK_ENDPOINT = '/services/api/notify-me/back-in-stock';
export const NOTIFY_ME_PRODUCT_RELEASE_ANNOUNCEMENT_ENDPOINT = '/services/api/notify-me/product-release';
// Endpoints Salesforce (for leasing page)
export const SALES_FORCE_LEASING_ENDPOINT = '/s/leasing-request-form';
// Dealer locator (graphql) services
export const DEALER_LOCATOR_ENDPOINT = '/services/api/dealers';
// Checkout Login
export const LOGIN_AS_GUEST_ENDPOINT = '/services/api/checkout/login';
// Checkout
export const CART_ORDER_CONVERSION_ENDPOINT = '/services/api/checkout/cart-order-conversion';
export const CHECKOUT_VALIDATION_STOCK_ENDPOINT = '/services/api/checkout/validate-stock';
export const CHECKOUT_RELEASE_INVENTORY = '/services/api/checkout/release-inventory';
// Checkout shipping details
export const UPDATE_SHIPPING_DETAILS_ENDPOINT = '/services/api/checkout/shipping-details';
export const PAYMENT_ADYEN_URL = '/services/api/checkout/payment';
export const PAYMENT_RESULT_URL = '/services/api/checkout/paymentResult';
export const PDP_LINKS_ENDPOINT = '/services/api/pdp-links';
export const ORDER_NOTIFICATION_ENDPOINT = '/services/api/checkout/request-order-notification';
// E-Invoice
export const EINVOICE_FISCAL_CODE_VALIDATION_ENDPOINT = '/services/api/checkout/fiscal-code';
export const EINVOICE_ITALY_CITIES_ENDPOINT = '/services/api/proxy/fiscal-code';
export const SHARE_CART_VIA_EMAIL_ENDPOINT = '/services/api/share-cart-via-email';
// Owner Manuals
export const OWNER_MANUALS_ENDPOINT = '/services/api/owner-manuals';
export const OWNER_MANUALS_CATEGORIES_ENDPOINT = '/services/api/owner-manuals-categories';
// Adobe tag manager checkout needs
export const TRANSACTION_DETAILS = '/services/api/checkout/payment-transaction-details';
// Test ride
export const TEST_RIDE_UNITS_ENDPOINT = '/services/api/test-ride/units';
export const TEST_RIDE_FORM_LINKS_ENDPOINT = '/services/api/test-ride/form-links';
export const TEST_RIDE_BOOK_ENDPOINT = '/services/api/test-ride/book';
export const TEST_RIDE_DEMO_UNITS_ENDPOINT = '/services/api/test-ride/demo-units';
export const TEST_RIDE_TIME_SLOTS_ENDPOINT = '/services/api/test-ride/time-slots';
export const TEST_RIDE_BOOK_WITH_TIME_SLOT_ENDPOINT = '/services/api/test-ride/book';
// Maintenance
export const MAINTENANCE_FORM_ENDPOINT = '/services/api/maintenance-form';
// Lead Generation Form
export const LEAD_GENERATION_FORM_ENDPOINT = '/services/api/lead-generation-form';
// Return Form
export const ORDER_DETAILS_ENDPOINT = '/services/api/return-form/order-details';
export const VALIDATE_PACKAGE_ENDPOINT = '/services/api/return-form/validate-package';
export const PDF_GENERATION_ENDPOINT = '/services/api/return-form/pdf-generation';
export const SUPPORT_NOTIFICATION_ENDPOINT = '/services/api/return-form/support-notification';
// Shipping methods
export const SHIPPING_METHODS_ENDPOINT = '/services/api/checkout/shipping-methods';
// Postal code
export const POSTAL_CODE_FORMAT_ENDPOINT = '/services/api/checkout/postal-code-format';
// Language selector
export const TARGET_PAGE_SERVICE_ENDPOINT = '/services/api/language-selector/target-page';
// Location resolver
export const CLIENT_LOCATION_ENDPOINT = '/services/api/client-location';
// Images
export const IMAGE_INFO_ENDPOINT = '/services/api/image-info';
// Newsletter
export const NEWSLETTER_SUBSCRIBE = '/services/api/newsletter/subscribe';
// Certificate
export const VALIDATE_CYCLE_SCHEME_CERT = '/services/api/cyclescheme/validate-cert';
export const REDEEM_CYCLE_SCHEME_CERT = '/services/api/cyclescheme/redeem-cert';
//Online payment by terminal
export const ONLINE_PAYMENT_TERMINAL = '/services/api/checkout/payment-with-terminal';
export const GOOGLE_AUTOCOMPLETE_ENDPOINT = '/services/api/google/autocomplete';
